// import React, { useRef, useCallback, useRef as useRefAlias } from "react";
// import Button from "../../../../components/Button/Button";
// import Icon10 from "../../../../icons/Icon10/Icon10";
// import "./style.scss";

// /* Avatars & flag */
// import avatar1 from "../../../../../static/img/avatar-1.png";
// import avatar2 from "../../../../../static/img/avatar-2.png";
// import avatar3 from "../../../../../static/img/avatar-3.png";
// import avatar4 from "../../../../../static/img/avatar-4.png";
// import avatar5 from "../../../../../static/img/avatar-5.png";
// import avatar6 from "../../../../../static/img/avatar-6.png";
// import flag6   from "../../../../../static/img/flag-6.png";

// /* ---- Data source for the carousel ----
//    Add/modify items here. `image` is optional if you later want to show a card picture.
// */
// const CARDS = [
//   {
//     id: "bill-walker",
//     user: { name: "Bill Walker", avatar: avatar5, flag: flag6, stats: "100% (25)" },
//     title: "Carey Price",
//     likes: "1.2k",
//     image: null,
//   },
//   {
//     id: "ward-funk",
//     user: { name: "Ward-Funk", avatar: avatar1, flag: flag6, stats: "100% (2)" },
//     title: "Patrick Roy",
//     likes: "1.2k",
//     image: null,
//   },
//   {
//     id: "charlene-little",
//     user: { name: "Charlene Little", avatar: avatar2, flag: flag6, stats: "100% (23)" },
//     title: "Patrick Roy",
//     likes: "1.2k",
//     image: null,
//   },
//   {
//     id: "barry-becker",
//     user: { name: "Barry Becker", avatar: avatar3, flag: flag6, stats: "100% (21)" },
//     title: "Patrick Roy",
//     likes: "1.2k",
//     image: null,
//   },
//   {
//     id: "audrey-rempel",
//     user: { name: "Audrey Rempel", avatar: avatar4, flag: flag6, stats: "99% (30)" },
//     title: "Patrick Roy",
//     likes: "1.2k",
//     image: null,
//   },
//   {
//     id: "marion-hirthe",
//     user: { name: "Marion Hirthe", avatar: avatar5, flag: flag6, stats: "99% (30)" },
//     title: "Connor McDavid",
//     likes: "1.2k",
//     image: null,
//   },
//   {
//     id: "jamie-feeney",
//     user: { name: "Jamie Feeney", avatar: avatar6, flag: flag6, stats: "99% (30)" },
//     title: "Jordan Eberle",
//     likes: "1.2k",
//     image: null,
//   },
// ];

// const CarouselCardsSubsection = ({title,t}) => {
//   const trackRef = useRef(null);

//   const scrollByOne = useCallback((dir = 1) => {
//     const el = trackRef.current;
//     if (!el) return;
//     const card = el.querySelector(".cc-card");
//     const gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap || "16");
//     const step = card ? card.getBoundingClientRect().width + gap : el.clientWidth * 0.8;
//     el.scrollBy({ left: dir * step, behavior: "smooth" });
//   }, []);

//   // drag-to-scroll
//   const isDown = useRefAlias(false);
//   const startX = useRefAlias(0);
//   const scrollLeft = useRefAlias(0);

//   const onMouseDown = e => {
//     const el = trackRef.current;
//     if (!el) return;
//     isDown.current = true;
//     el.classList.add("dragging");
//     startX.current = e.pageX - el.offsetLeft;
//     scrollLeft.current = el.scrollLeft;
//   };
//   const onMouseLeave = () => {
//     isDown.current = false;
//     trackRef.current?.classList.remove("dragging");
//   };
//   const onMouseUp = () => {
//     isDown.current = false;
//     trackRef.current?.classList.remove("dragging");
//   };
//   const onMouseMove = e => {
//     const el = trackRef.current;
//     if (!isDown.current || !el) return;
//     e.preventDefault();
//     const x = e.pageX - el.offsetLeft;
//     const walk = (x - startX.current) * 1.1;
//     el.scrollLeft = scrollLeft.current - walk;
//   };

//   return (
//     <>
//     <span aria-hidden className="page-arc" />
//     <div className="hero__carousel__viewTitle">
// <h2 className="cc-title">{title}</h2>
//   <h4 className="cc-ViewMore"><a className="cc-ACenter">{t('View More')}</a></h4>
//   </div>
// <div className="cards-carousel" aria-label="Featured cards">
//   {/* side arrows */}
//   <button
//     className="cc-arrow is-left"
//     onClick={() => scrollByOne(-1)}
//     aria-label="Scroll left"
//   >
//     ‹
//   </button>
//   <button
//     className="cc-arrow is-right"
//     onClick={() => scrollByOne(1)}
//     aria-label="Scroll right"
//   >
//     ›
//   </button>

//   {/* scroll track */}
//   <div
//     className="cc-track"
//     ref={trackRef}
//     role="region"
//     aria-roledescription="carousel"
//     aria-label="Card list"
//     tabIndex={0}
//     onMouseDown={onMouseDown}
//     onMouseLeave={onMouseLeave}
//     onMouseUp={onMouseUp}
//     onMouseMove={onMouseMove}
//   >
//         {CARDS.map(card => (
//           <article key={card.id} className="cc-card" aria-label={`${card.title} by ${card.user.name}`}>
//             {/* Header with stats on the right */}
//             <header className="cc-user">
//               <div className="cc-user-left">
//                 <img className="avatar" alt="" src={card.user.avatar} />
//                 <span className="name">{card.user.name}</span>
//               </div>
//               <div className="cc-user-right">
//                 <span className="stats">{card.user.stats}</span>
//                 <img className="flag" alt="" src={card.user.flag} />
//               </div>
//             </header>

//             {/* Media (optional image hook) */}
//             <figure className="cc-media" style={card.image ? { backgroundImage: `url(${card.image})`, backgroundSize: "cover", backgroundPosition: "50% 50%" } : undefined}>
//               <figcaption className="likes">
//                 <span className="like-pill">
//                   <Icon10 className="icon-10" color="#E68F8F" />
//                   <span className="count">{card.likes}</span>
//                 </span>
//               </figcaption>
//             </figure>

//             {/* Title + (we'll hide the sub via CSS since stats moved to header) */}
//             <div className="cc-meta">
//               <div className="title">{card.title}</div>
//               {/* <div className="sub">{card.user.stats}</div> */}
            
//             </div>

//             <Button
//               className="cc-buy"
//               icon={false}
//               size="default"
//               state="default"
//               text="Buy it Now"
//               type="primary"
//             />
//           </article>
//         ))}
//       </div>
     
//     </div>
    
// </>  );
// };

// export default CarouselCardsSubsection;
// CarouselCardsSubsection.jsx
import React, { useEffect,useState,useRef, useCallback, useMemo,useContext } from "react";
import { AuthContext } from "../../../../../../components/login/AuthContext";
import Button from "../../../../components/Button/Button";
import Icon10 from "../../../../icons/Icon10/Icon10";
import FavoriteIcon from "./../../../../../../components/Favorite/FavoriteIcon";
  import SaleModals from "../../../../../../components/GridViewSellTrade/SaleModals";
import { hasConsent } from "../../../../../../components/login/hasConsent";

import { getCountryCode } from "../../../../../../components/UsefulComponent/CountryMapping";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import BigShowCompleteCard from "../../../../../../components/Card/BigShowCompleteCard";
import { useFavorites } from "../../../../../../components/Favorite/FavoriteProvider";
const CarouselCardsSubsection = ({ title, t,i18n }) => {
  const trackRef = useRef(null);
  const navigate = useNavigate();
const [items, setItems] = useState([]);
const [loading, setLoading] = useState(true);
 const { userId, liveCsrfToken } = useContext(AuthContext);
  const scrollByOne = useCallback((dir = 1) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector(".cc-card");
    const gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap || "16");
    const step = card ? card.getBoundingClientRect().width + gap : el.clientWidth * 0.8;
    el.scrollBy({ left: dir * step, behavior: "smooth" });
  }, []);
  const {
    favoriteSellers,
    setFavoriteCards,
    favoriteCards,
    addFavoriteCard,
    removeFavoriteCard,
  } = useFavorites();



  // ---- helpers
const get = (o, path) => path.split('.').reduce((acc, p) => (acc ? acc[p] : undefined), o);
const firstPathWithValue = (obj, candidates) =>
  candidates.find(p => get(obj, p) != null);

// ---- adapter
const adaptFeatured = (raw, t) => {
  // Deep source (supports Cards.Cards.*, card.*, or the root)
  const deepBasePath = firstPathWithValue(raw, ["Cards.Cards", "card", "Cards", "data"]);
  const deep = deepBasePath ? get(raw, deepBasePath) : raw;

  // Ids (IMPORTANT: userCardId vs CardId)
  const userCardId = deep?.userCardId ?? raw?.userCardId ?? deep?.id ?? raw?.id;
  const cardId     = deep?.CardId     ?? raw?.CardId;

  // Image
  const image = deep?.ImageFront || deep?.Image || raw?.ImageFront || raw?.Image || null;

  // Price (prefer SalePrice > Price > LaValeur)
  const priceRawPath = firstPathWithValue({ ...deep, ...raw }, ["SalePrice","Price","LaValeur","price","prix"]);
  const price = Number(priceRawPath ? get({ ...deep, ...raw }, priceRawPath) : 0) || 0;

  // TV / Estimate
  const tvRawPath = firstPathWithValue({ ...deep, ...raw }, ["EstimateValue","TV","estimate"]);
  const estimate  = Number(tvRawPath ? get({ ...deep, ...raw }, tvRawPath) : 0) || 0;

  // ForSale/ForTrade (support many casings and string enums)
  const forSaleRaw  = (deep?.IsForSale ?? raw?.IsForSale ?? deep?.isForSale ?? raw?.isForSale);
  const forTradeRaw = (deep?.IsForTrade ?? raw?.IsForTrade ?? deep?.isForTrade ?? raw?.isForTrade);

  const isForSale =
    forSaleRaw === true || forSaleRaw === 1 || String(forSaleRaw).toLowerCase() === "isforsale";

  const isForTrade =
    forTradeRaw === true || forTradeRaw === 1 || String(forTradeRaw).toLowerCase() === "isfortrade";

  // Value to show (business choice: hide "0$" → use > 0; change to >= 0 if you want to show 0)
  const showPrice = isForSale && price > 0;
  const showTV    = !showPrice && estimate > 0;

  // Seller bits
  const name   = deep?.ShowName ?? raw?.ShowName ?? "Collector";
  const avatar = deep?.ProfilPicture ?? raw?.ProfilPicture;
  const tx     = deep?.NumberOfTransactions ?? raw?.NumberOfTransactions ?? 0;
  const rating = deep?.AverageRating ?? raw?.AverageRating ?? 0; // 0..5
  const ratingPct = Math.round((rating * 20) * 10) / 10;         // → percent with 1 decimal

  const countryCode =
    (deep?.CountryCode ?? raw?.CountryCode) ||
    getCountryCode(deep?.Country ?? raw?.Country ?? "CA") ||
    "CA";

  // Social
  const likes = deep?.ViewCounts ?? raw?.ViewCounts ?? deep?.WatchListCounts ?? raw?.WatchListCounts ?? 0;

  return {
    // ids for routing + favorite API
    userCardId,          // route id (/cards/:userCardId)
    cardId,              // catalog id
    navigateId: userCardId,

    // media
    image,

    // value display
    hasValue: showPrice || showTV,
    label: showPrice ? t("Price") : "TV",
    amount: showPrice ? price : estimate,

    // seller
    seller: {
      userId: deep?.UserId ?? raw?.UserId,
      name,
      avatar,
      tx,
      ratingPct,
      flagCode: String(countryCode).toLowerCase(),
    },

    // commerce flags
    commerce: { isForSale, isForTrade, price, estimate },

    // social
    likes,
  };
};

// états locaux pour modals
const [selectedSaleCard, setSelectedSaleCard] = useState(null);
const [isSaleModalOpen, setIsSaleModalOpen]   = useState(false);
const [selectedTradeCard, setSelectedTradeCard] = useState(null);
const [isTradeModalOpen, setIsTradeModalOpen]   = useState(false);

const openSale = (card) => { setSelectedSaleCard(card); setIsSaleModalOpen(true); };
const openTrade = (card) => { setSelectedTradeCard(card); setIsTradeModalOpen(true); };



  const toggleFavorite = async (cardUserCardId, cardId) => {
    if (!userId) {
      // Save the intended path to local storage

       if (hasConsent()) {
      localStorage.setItem(
        "intendedPath",
        window.location.pathname + window.location.search
      );}
     
      navigate(i18n.language === 'fr' ? `/fr/login`:`/login`)
      return;
    }
    //fetchCollectionsCards()
    // Check if the card is currently in favoriteCards
    console.log(
      "favorite favoriteCards  cardUserCardId,cardId",
      favoriteCards,
      cardUserCardId,
      cardId
    );
    const favoriteCardInfo = favoriteCards.find(
      (card) => card.userCardId === cardUserCardId
    );
    const isCurrentlyFavorite = Boolean(favoriteCardInfo);
    let newWatchListId;

    try {
      if (isCurrentlyFavorite) {
        // Remove from watchlist
        await removeFavoriteCard(cardUserCardId);

        newWatchListId = null;
      } else {
        // Add to watchlist
        await addFavoriteCard(cardUserCardId, cardId);
        newWatchListId = favoriteCardInfo?.WatchListId || null;
      }

      // Update the state after successful API response
      setFavoriteCards(
        (prevFavorites) =>
          isCurrentlyFavorite
            ? prevFavorites.filter((card) => card.userCardId !== cardUserCardId) // Remove the card
            : [
                ...prevFavorites,
                { userCardId: cardUserCardId, WatchListId: newWatchListId },
              ] // Add the card
      );

      console.log(
        "Favorite status updated for card:",
        cardUserCardId,
        "New WatchListId:",
        newWatchListId
      );
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };



useEffect(() => {
  (async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/marketplace/getSellingCardsLimit10`, { credentials: "include" });
      const json = await res.json();
      console.log('fetched featured',json);
      setItems(json || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  })();
}, []);


  // drag-to-scroll (unchanged)
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);
  const onMouseDown = e => {
    const el = trackRef.current;
    if (!el) return;
    isDown.current = true;
    el.classList.add("dragging");
    startX.current = e.pageX - el.offsetLeft;
    scrollLeft.current = el.scrollLeft;
  };
  const onMouseLeave = () => { isDown.current = false; trackRef.current?.classList.remove("dragging"); };
  const onMouseUp = () => { isDown.current = false; trackRef.current?.classList.remove("dragging"); };
  const onMouseMove = e => {
    const el = trackRef.current;
    if (!isDown.current || !el) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startX.current) * 1.1;
    el.scrollLeft = scrollLeft.current - walk;
  };

  // Adapt server items → UI model (safe fallbacks)
  const cards = useMemo(() => {
    return (items || []).map((c, idx) => ({
      id: c.id ?? c.userCardId ?? `card-${idx}`,
      title: [c.Name, c.NumberBehind ? `#${c.NumberBehind}` : null].filter(Boolean).join(" ") || c.cardName || t?.("Card") || "Card",
      card:c,
      isForSale: c.IsForSale === true || c.IsForSale === "isForSale" ? "isForSale" : c.IsForSale === false || c.IsForSale === "notForSale" ? "notForSale" : "unknown",
      isForTrade: c.IsForTrade === true || c.IsForTrade === "isForTrade" ? "isForTrade" : c.IsForTrade === false || c.IsForTrade === "notForTrade" ? "notForTrade" : "unknown",
      Price: c.Price != null ? Number(c.Price) : null,
      EstimateValue: c.EstimateValue != null ? Number(c.EstimateValue) : null,
      image: c.ImageFront || c.Image || null,
      likes: c.ViewCounts ?? c.FavoritesCount ?? 0,
      user: {
        name: c.ShowName || c.UserName || "Collector",
        avatar: c.ProfilPicture || c.ProfilePicture || undefined,
        flag: c.CountryCode ? `https://flagcdn.com/24x18/${String(c.CountryCode).toLowerCase()}.png` : undefined,
        stats: c.NumberOfTransactions != null && c.AverageRating != null
          ? `${Math.round((c.AverageRating || 0) * 20)}% (${c.NumberOfTransactions})`
          : null,
      },
      navigateId: c.id ?? c.userCardId, // used for /cards/:id
    }));
  }, [items, t]);

  return (
    <>
      <span aria-hidden className="page-arc" />
      <div className="hero__carousel__viewTitle">
        <div className="cc-titleWrap">
        <h2 className="cc-title">{title}</h2>
        <p className="cc-subtitle">
          {t?.("Explore cards listed by real collectors.") || "Explore cards listed by real collectors."}
        </p>
      </div>
         </div>
  <h4 className="cc-ViewMore"><a className="cc-ACenter" onClick={()=> navigate(i18n.language === 'fr' ? '/fr/marketplace' : '/marketplace')}>{t?.("View More") || "View More"}</a></h4>
     
      <div className="cards-carousel" aria-label="Featured Hockey & Pokémon Cards">
        <button className="cc-arrow is-left" onClick={() => scrollByOne(-1)} aria-label="Scroll left">‹</button>
        <button className="cc-arrow is-right" onClick={() => scrollByOne(1)} aria-label="Scroll right">›</button>

        <div
          className="cc-track"
          ref={trackRef}
          role="region"
          aria-roledescription="carousel"
          aria-label="Card list"
          tabIndex={0}
          onMouseDown={onMouseDown}
          onMouseLeave={onMouseLeave}
          onMouseUp={onMouseUp}
          onMouseMove={onMouseMove}
        >
{cards.length === 0 ? (
  <div className="cc-empty">{t?.("No featured listings available.") || "No featured listings available."}</div>
) : (
  cards.map(raw => {
    // raw is your previous "card adapter" object; we pass raw.card if present
    const card = adaptFeatured(raw.card ?? raw, t);
    if (!card?.navigateId) return null;

    return (
      <article
        key={card.userCardId}
        className="cc-card cc-card--featured"
        onClick={() => navigate(`/cards/${card.navigateId}`)}
        aria-label={`${card.seller.name}`}
      >
        {/* Seller row */}
        <header className="cc-user">
          <div className="cc-user-left">
            {card.seller.avatar
              ? <img className="avatar" alt="" src={card.seller.avatar} />
              : <span className="avatar placeholder" />}
            <span className="name">{card.seller.name}</span>
          </div>
          <div className="cc-user-right">
            <span className="stats">{card.seller.ratingPct}% ({card.seller.tx})</span>
            {card.seller.flagCode && (
              <img className="country-flag" alt="" src={`https://flagcdn.com/24x18/${card.seller.flagCode}.png`} />
            )}
          </div>
        </header>

        {/* Image + Favorite */}
        <figure
          className="cc-media"
          style={card.image ? { backgroundImage: `url(${card.image})`, backgroundSize: "cover", backgroundPosition: "50% 50%" } : undefined}
        >
          <div className="cc-fav"  onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
            <FavoriteIcon
              key={`fav-${card.userCardId}`}
              cardUserCardId={card.userCardId}    
              cardId={card.cardId}               
              isFavorite={favoriteCards.some(fc => fc.userCardId === card.userCardId)}
              toggleFavorite={(...args) => {
                // ensure favorite button doesn't navigate
                // your provider `toggleFavorite` signature: (userCardId, cardId)
                args[2]?.stopPropagation?.(); // if FavoriteIcon forwards event
                toggleFavorite(card.userCardId, card.cardId);
              }}
              cardUserId={card.seller.userId}
              userId={userId}
              size={30}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </figure>

        {/* Price/TV + CTAs */}
        {card.hasValue && (
          <div className="cta-row-grid">
            <div className="cta-leftStack">
              <span className="meta-label">{card.label}</span>
              <span className="meta-amount">
                {Number(card.amount || 0).toLocaleString(undefined, {
                  style: "currency",
                  currency: "CAD",
                  currencyDisplay: "narrowSymbol",
                })}
              </span>
            </div>
            <div className="cta-right">
              {card.commerce.isForSale && (
                <button
                  className="cta-icon-button cta-icon--buy"
                  type="button"
                  //onClick={(e) => { e.preventDefault(); e.stopPropagation(); openSale(raw.card ?? raw); }}
                  aria-label={t("Buy It Now")}
                  title={t("Buy It Now")}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 1v22M17 6c0-2.761-2.686-5-6-5S5 3.239 5 6s2.686 5 6 5 6 2.239 6 5-2.686 5-6 5-6-2.239-6-5"
                          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>
              )}
              {card.commerce.isForTrade && (
                <button
                  className="cta-icon-button cta-icon--trade"
                  type="button"
                 // onClick={(e) => { e.preventDefault(); e.stopPropagation(); openTrade(raw.card ?? raw); }}
                  aria-label={t("Trade")}
                  title={t("Trade")}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M7 7h13l-3.5-3.5M17 17H4l3.5 3.5"
                          fill="none" stroke="currentColor" strokeWidth="2"
                          strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              )}
            </div>
          </div>
        )}
      </article>
    );
  })
)}


        </div>
      </div>
    </>
  );
};

export default CarouselCardsSubsection;
